import FileName from './component'
export { FileName }
export default FileName